module.exports = __webpack_public_path__ + "static/media/exp-shield.2518c0b7.png";